import { ComponentProps } from "react"
import { SwitcherTwo as ToggleExterno } from 'components/toggle-2'

const ToggleTwo = (props: ComponentProps<typeof ToggleExterno>) => {
  return <ToggleExterno {...props} />
}

export { ToggleTwo }
